import {
  Box,
  Button,
  CardMedia,
  Dialog,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { ProceedSaveLater, SubHeading } from './components';
import UseRadioGroup, { UseRadioGroupTransparent } from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import {
  Formik,
  setNestedObjectValues,
  useFormikContext,
  validateYupSchema,
  yupToFormErrors,
  // useFormikContext,
} from 'formik';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import { Applicant } from '../../redux-store/types/api-types';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_LISTING_STATUS,
  genderMasters,
  salutationsMasters,
  USER_ROLES,
  ONBOARDING_INVESTOR,
  YesNoMaster,
  ModeOfOprationMaster,
  panCopyConsiderationDate,
  AccridiatedInvestorNoOptionHideConsiderationDate,
} from '../../utils/constant';
import {
  getApplicantName,
  getApplicantType,
  getFirstHolderName,
  minDateForContributor,
  saveForLater,
  applyRoleBasedStatus,
  applicationComparison,
  sendApplication_Nri,
  removeSingleQuote,
  USTaxableUSNonTaxableInvestorAccess,
  accreditedInvestorTypeCapture,
  doYouHavePanCopy,
  checkValidationBasedOnDate,
  investorSubCategoryNRIorOCI,
  accreditedInvestorPresent,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import { ConfirmationDialog } from '../commonComponents';
import { contributorDetailsSchema } from '../../utils/schema';
import {
  getAccridiatedInfo,
  getInvestorCategory,
  getNationalityList,
} from '../../redux-store/actions';

import {
  mdmsAccridiatedInfoType,
  mdmsCountriesList,
  mdmsInvestorCategoryType,
  nationaliyType,
} from '../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
import { showError } from '../../redux-store/actions/auth';

const contributorObject: Partial<Applicant> = {
  // name: '',
  firstName: '',
  lastName: '',
  middleName: '',
  namePrefix: '',
  // motherName: '',
  fatherOrSpouseName: '',
  dateOfBirth: minDateForContributor().toString(),
  // status: '',
  nationality: '',
  taxIdNumber: '',
  countryNationality: '',
  // relationShipWithFirstApplicant: '',
  // mobile: '',
  gender: '',
  investorType: '',
  investorCategory: '',
  investorSubCategory: '',
  accreditedInvestorType: '',
  isAccreditedInvestor: 'yes',
  sno: 0,
  panCardAvailable: '',
  panNumber: '',
};
type updateApplicant = Applicant;
// & {
//   jointApplicantRelation: string | null;
// };
export type Values = {
  modeOfHolding: string;
  applicants: Partial<updateApplicant>[];
  // poaHolderName: string;
  applicationSource: string;
  folio_no: string | null;
  saveType: string;
  nationalityDropdown: string[];
  applicationType: string;
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  // poaHolderName: '',
  applicationSource: 'digitalonboarding',
  folio_no: '',
  saveType: 'save and proceed',
  applicationType: '',
  nationalityDropdown: [],
};

const HolderDetails = ({
  index,
  values,
  nationalitiesMdmsResponse,
  applicationStatus,
  mdmsInvestorType,
  accridiatedInfo,
}: {
  index: number;
  values: Values;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  mdmsInvestorType: mdmsInvestorCategoryType;
  applicationStatus?: string;
  accridiatedInfo: mdmsAccridiatedInfoType;
}): JSX.Element => {
  const { setFieldValue } = useFormikContext();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { createdAt = '' } = application || {};
  const isFieldDisabled = [USER_ROLES.POAAPPROVER].includes(role);
  const [open, setOpen] = useState<{
    index: number;
    status: string;
  } | null>(null);

  const handleOpen = (index: number, status: string) => {
    setOpen({ index, status });
  };
  const handleClose = () => {
    setOpen(null);
  };
  return (
    <>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.firstName`}
          label="First Name *"
          placeholder="Enter First Name"
          startAdornment={
            <InputAdornment
              position="start"
              sx={{
                pr: '0 !important',
                mx: '0 !important',
                borderRight: '0 !important',
              }}>
              <MFSelectField
                name={`applicants.${index}.namePrefix`}
                items={salutationsMasters.map((salutation) => ({
                  key: salutation,
                  value: salutation,
                }))}
                disabled={isFieldDisabled}
                sx={{
                  color: 'primary.main',
                  '.MuiSvgIcon-root ': { color: 'primary.main' },
                  '&.MuiInputBase-root': {
                    '.MuiSelect-select': {
                      p: 0,
                      pr: 2.5,
                      border: 0,
                    },
                  },
                  '&,&:hover,&.Mui-focused': { '.MuiOutlinedInput-notchedOutline': { border: 0 } },
                }}
              />
            </InputAdornment>
          }
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.middleName`}
          label="Middle Name"
          placeholder="Enter Middle Name"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.lastName`}
          label="Last Name *"
          placeholder="Enter Last Name"
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.gender`}
          label="Gender *"
          items={genderMasters.map((gender) => ({ key: gender, value: gender }))}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextDatePicker
          label={'Date of birth *'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Date of birth'}
          // maxDate={minDateForContributor()}
          name={`applicants.${index}.dateOfBirth`}
          disabled
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.fatherOrSpouseName`}
          label="Father Name *"
          placeholder="Enter Father Name"
        />
      </Grid>

      <Grid item xs={12} sm={6} sx={{ mt: 1.5 }}>
        <UseRadioGroup
          formLabel="Investor Type *"
          name={`applicationType`}
          items={Object.keys(ONBOARDING_INVESTOR).map((option) => ({
            label: ONBOARDING_INVESTOR[option],
            value: option,
          }))}
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.investorCategory`}
          label={`Investor Category *`}
          items={(Object?.keys(mdmsInvestorType) || [])?.map((item) => ({
            key: mdmsInvestorType[item].displayText,
            value: item,
          }))}
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.investorSubCategory`}
          label={`Investor Sub-Category *`}
          items={mdmsInvestorType[
            values.applicants[index].investorCategory || ''
          ]?.subCategory?.map((item) => ({
            key: item.label,
            value: item.key,
          }))}
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MFTextField
          name={`applicants.${index}.taxIdNumber`}
          label="Primary Tax Id *"
          placeholder="Enter Primary Tax Id"
          // disabled
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SearchableSelect
          name={`applicants.${index}.nationality`}
          label="Country of Tax Residency *"
          items={nationalitiesMdmsResponse.map((nationality) => ({
            key: nationality.nationality,
            value: nationality.nationality,
          }))}
          disabled
          searchFieldPlaceholder={'Search Country of Tax Residency'}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SearchableSelect
          name={`applicants.${index}.countryNationality`}
          label="Nationality of Applicant *"
          items={nationalitiesMdmsResponse.map((nationality) => ({
            key: nationality.nationality,
            value: nationality.nationality,
          }))}
          disabled
          searchFieldPlaceholder={'Search Nationality'}
        />
      </Grid>
      {investorSubCategoryNRIorOCI(values.applicants[index].investorSubCategory || '') &&
        checkValidationBasedOnDate(createdAt, panCopyConsiderationDate) && (
          <Grid item xs={12} sm={12} sx={{ mt: 1.5 }}>
            <UseRadioGroup
              formLabel={`Do you have a Pan Card? *`}
              name={`applicants.${index}.panCardAvailable`}
              items={Object.keys(YesNoMaster).map((option) => ({
                label: YesNoMaster[option],
                value: option,
              }))}
            />
          </Grid>
        )}
      {doYouHavePanCopy(values.applicants[index].panCardAvailable || '') && (
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.panNumber`}
            label="Pan Number *"
            placeholder="Enter Pan Number"
            inputProps={{ style: { textTransform: 'uppercase' } }}
          />
        </Grid>
      )}
      {accreditedInvestorPresent(
        values.applicants[index].investorCategory || '',
        application?.createdAt || ''
      ) && (
        <>
          <Grid item xs={12} sm={12} sx={{ mt: 1.5 }}>
            <UseRadioGroup
              formLabel="Accredited Investor *"
              name={`applicants.${index}.isAccreditedInvestor`}
              items={Object.keys(YesNoMaster)
                .filter((option) => {
                  return (
                    (YesNoMaster[option] !== YesNoMaster.no &&
                      checkValidationBasedOnDate(
                        application?.createdAt || '',
                        AccridiatedInvestorNoOptionHideConsiderationDate
                      )) ||
                    !checkValidationBasedOnDate(
                      application?.createdAt || '',
                      AccridiatedInvestorNoOptionHideConsiderationDate
                    )
                  );
                })
                .map((option) => ({
                  label: YesNoMaster[option],
                  value: option,
                }))}
            />
          </Grid>
          {accreditedInvestorTypeCapture(
            values.applicants[index].isAccreditedInvestor || '',
            values.applicants[index].investorCategory || ''
          ) && (
            <Grid item xs={12} sm={12} sx={{ mt: 1.5 }}>
              <UseRadioGroupTransparent
                name={`applicants.${index}.accreditedInvestorType`}
                items={Object.keys(accridiatedInfo).map((option) => ({
                  label: accridiatedInfo[option].label,
                  info: accridiatedInfo[option]?.info,
                  value: option,
                }))}
                row={false}
              />
            </Grid>
          )}
        </>
      )}
      <ConfirmationDialog
        message={`Any change in the investor status will affect the application's status and workflow. Are you sure you want to proceed?`}
        open={open !== null}
        setOpen={handleClose}
        onSave={() => {
          setFieldValue(`applicants.${open?.index}.status`, open?.status);
          setFieldValue(`applicants.${open?.index}.nationality`, 'INDIAN');
          handleClose();
        }}
        onCancel={handleClose}
      />
    </>
  );
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const [applicantToDelete, setApplicantToDelete] = useState<{
    index: number;
  } | null>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const [accridiatedInfo, setAccridiatedInfo] = useState<mdmsAccridiatedInfoType>(
    {} as mdmsAccridiatedInfoType
  );
  const [mdmsInvestorType, setMdmsInvestorType] = useState<mdmsInvestorCategoryType>({});

  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const categoryMasters = (await dispatch(
          getInvestorCategory()
        )) as unknown as mdmsInvestorCategoryType;
        setMdmsInvestorType(categoryMasters);
        const accridiatedInfoMasters = (await dispatch(
          getAccridiatedInfo()
        )) as unknown as mdmsAccridiatedInfoType;
        setAccridiatedInfo(accridiatedInfoMasters);
        const {
          applicants = [],
          modeOfHolding = '',
          applicationSource = 'digitalonboarding',
          // folio_no = '',
          applicationType = '',
          createdAt = '',
        } = application || {};
        const sortedApplicants = applicants
          .map((applicant) => ({
            ...applicant,
            applicant_type: getApplicantType(applicant.applicant_type),
          }))
          .sort((applicant1, applicant2) => {
            return Number(applicant1.applicant_type) - Number(applicant2.applicant_type);
          });
        setContributorValues({
          ...contributorValues,
          applicationType,
          // folio_no: folio_no,
          applicationSource: applicationSource || 'digitalonboarding',
          modeOfHolding:
            modeOfHolding === 'jointWithRightOfSurvivorship'
              ? 'jointWithRightOfSurvivorship'
              : sortedApplicants.length > 1
              ? 'joint'
              : modeOfHolding,
          applicants: applicants.length
            ? sortedApplicants.map((applicant, index) => ({
                ...applicant,
                // status: applicant.status || 'Individual',
                namePrefix:
                  applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
                    ? applicant.namePrefix
                    : 'Mr.',
                isAccreditedInvestor: accreditedInvestorPresent(
                  applicant.investorCategory || '',
                  createdAt
                )
                  ? applicant.isAccreditedInvestor
                  : '',
                accreditedInvestorType:
                  accreditedInvestorPresent(applicant.investorCategory || '', createdAt) &&
                  accreditedInvestorTypeCapture(
                    applicant.isAccreditedInvestor || '',
                    applicant.investorCategory || ''
                  )
                    ? applicant.accreditedInvestorType
                    : '',
                sno: index,
                panCardAvailable: applicant.panCardAvailable || '',
                investorSubCategory: applicant?.investorSubCategory || '',
              }))
            : [contributorObject],
          nationalityDropdown: nationalitiesMdmsMasters.countries.map((list) => list.nationality),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  // const validate = (values: Values): FormikErrors<Values> => {
  //   let errors: FormikErrors<Values> = {};
  //   const { applicants, poaHolderName } = values;
  //   if (applicants.length > 1 && !poaHolderName) {
  //     errors = { ...errors, poaHolderName: 'Please select POA' };
  //   }
  //   return errors;
  // };

  const handleApplicant = async (values: Values, AddJointHolder: boolean) => {
    const { applicants = [], modeOfHolding = '', saveType, folio_no, applicationSource } = values;
    const {
      id,
      currentStep,
      hasPOA,
      status,
      applicant1ReferenceId = '',
      applicationNumber,
      createdAt = '',
    } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;

    const updatedApplicants = values.applicants.map((applicant) => {
      const {
        // jointApplicantRelation,
        sno,
        ...rest
      } = applicant;
      return {
        ...rest,
        // name: removeSingleQuote(applicant.name),
        firstName: removeSingleQuote(applicant.firstName),
        middleName: removeSingleQuote(applicant.middleName),
        lastName: removeSingleQuote(applicant.lastName),
        fatherOrSpouseName: removeSingleQuote(applicant.fatherOrSpouseName),
        isAccreditedInvestor: accreditedInvestorPresent(applicant.investorCategory || '', createdAt)
          ? applicant.isAccreditedInvestor
          : '',
        accreditedInvestorType:
          accreditedInvestorPresent(applicant.investorCategory || '', createdAt) &&
          accreditedInvestorTypeCapture(
            applicant.isAccreditedInvestor || '',
            applicant.investorCategory || ''
          )
            ? applicant.accreditedInvestorType
            : '',
        panCardAvailable:
          investorSubCategoryNRIorOCI(applicant.investorSubCategory || '') &&
          checkValidationBasedOnDate(createdAt, panCopyConsiderationDate)
            ? applicant?.panCardAvailable
            : null,
        panNumber: doYouHavePanCopy(applicant.panCardAvailable || '')
          ? applicant?.panNumber?.toUpperCase()
          : null,
      };
    });
    updatedApplicants?.forEach((applicant) => {
      if (applicant.isAccreditedInvestor?.toString() === 'no') {
        throw 'Non-accredited investor is not allowed to proceed further';
      }
    });
    const updatedModeOfHolding =
      applicants.filter((applicant) => applicant.isActive).length === 1 ? 'single' : modeOfHolding;
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        // folio_no: folioValidationCheck(applicationSource as string) ? folio_no : '',
        applicationSource,
        applicants: updatedApplicants?.sort(
          (applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)
        ),
        modeOfHolding: updatedModeOfHolding,
        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );
    const isSaveLater = saveType !== 'save and proceed';
    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ...application!,
            applicants: updatedApplicants,
            modeOfHolding: updatedModeOfHolding,
            // folio_no: folioValidationCheck(applicationSource as string) ? folio_no : '',
            // applicationSource,
            ...(saveType === 'save and proceed' && {
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : (sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
                      APPLICATION_LISTING_STATUS[status as string] ===
                        APPLICATION_LISTING_STATUS.sent_to_applicant1) ||
                    (!sendApplication_Nri({ ...application!, applicants: updatedApplicants }) &&
                      APPLICATION_LISTING_STATUS[status as string] ===
                        APPLICATION_LISTING_STATUS.sent_to_amc_approver)
                  ? 'draft'
                  : status,
            }),
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //     ? 2
            //     : currentStep
            //   : applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //     isAllBanksPennyChecked
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
    } else if (checkApplication) {
      if (isSaveLater) {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
    }
    const routeToSaveForLater = isSaveLater && saveForLater(role, id, applicant1ReferenceId);
    !AddJointHolder
      ? !isSaveLater
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : routeToSaveForLater && history.push(routeToSaveForLater)
      : history.push('../onboarding/investor-onboarding', {
          redirectTo: `../application/contributor-details`,
          application,
          firstHolderName: getFirstHolderName(values.applicants),
        });
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      await handleApplicant(values, false);
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={contributorValues}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            contributorDetailsSchema(
              accridiatedInfo,
              mdmsCountriesList,
              application?.createdAt || ''
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({
        handleSubmit,
        values,
        setValues,
        validateForm,
        setErrors,
        setTouched,
        setFieldValue,
      }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {USER_ROLES.INVESTOR !== role && (
              <>
                {/* <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }} mb={2}>
                  <UseRadioGroup
                    formLabel="Application Source"
                    name="applicationSource"
                    defaultValue="digitalonboarding"
                    items={Object.keys(ApplicationSourceMaster).map((source) => ({
                      label: ApplicationSourceMaster[source],
                      value: source,
                    }))}
                    // disabled={true}
                  />
                </Grid> */}
                {/* {folioValidationCheck(values.applicationSource) && (
                  <Grid item xs={12} sm={6} mb={2}>
                    <MFTextField
                      name={`folio_no`}
                      label={`Folio Number ${
                        folioValidationCheck(values.applicationSource) ? '*' : ''
                      }`}
                      placeholder="Enter Folio Number"
                    />
                  </Grid>
                )} */}
              </>
            )}

            {values.applicants
              ?.filter((item) => item.isActive)
              .map((applicant, index) => (
                <React.Fragment key={index}>
                  <SubHeading
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                    Contributor details of {getApplicantName(index + 1)} Applicant
                    {index !== 0 && (
                      <Box
                        sx={{ display: 'flex', alignItems: 'center' }}
                        onClick={() => setApplicantToDelete({ index: applicant.sno as number })}>
                        <Typography
                          sx={{
                            color: 'rgba(196, 42, 51, 0.8)',
                            fontSize: 12,
                            ml: 'auto',
                            letterSpacing: '-0.2px',
                            cursor: 'pointer',
                          }}>
                          Remove Joint Holder{' '}
                        </Typography>
                        <IconButton sx={{ p: '2px' }}>
                          <CardMedia
                            component="img"
                            src="/images/delete-red.svg"
                            alt="Delete Icon"
                            sx={{ width: 'unset' }}
                          />
                        </IconButton>
                      </Box>
                    )}
                  </SubHeading>
                  <HolderDetails
                    index={applicant.sno as number}
                    values={values}
                    nationalitiesMdmsResponse={mdmsCountriesList}
                    applicationStatus={application?.status}
                    mdmsInvestorType={mdmsInvestorType}
                    accridiatedInfo={accridiatedInfo}
                  />
                </React.Fragment>
              ))}
            {!!values.applicants?.filter((item) => item.isActive).length &&
              values.applicants?.filter((item) => item.isActive).length < 2 &&
              ![USER_ROLES.POAAPPROVER].includes(role) && (
                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    startIcon={<AddIcon />}
                    sx={{
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      mt: 2,
                    }}
                    onClick={async () => {
                      try {
                        const formErrors = await validateForm();
                        if (!Object.keys(formErrors).length) {
                          await handleApplicant(values, true);
                          return;
                        }
                        setTouched(setNestedObjectValues(formErrors, true));
                        setErrors(formErrors);
                      } catch (e) {
                        typeof e === 'string' && dispatch(showError(e));
                        console.error((e as Error).message);
                      }
                    }}>
                    Add Joint Holder
                  </Button>
                </Grid>
              )}
            {values.applicants?.filter((item) => item.isActive).length > 1 && (
              <>
                <SubHeading>Mode of Operations</SubHeading>
                <Grid item xs={12} sm={6} sx={{ mt: 1.5 }}>
                  <UseRadioGroupTransparent
                    name={`modeOfHolding`}
                    items={Object.keys(ModeOfOprationMaster)?.map((item) => ({
                      label: ModeOfOprationMaster[item],
                      value: item,
                    }))}
                    row={false}
                  />
                </Grid>
              </>
            )}
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                    // relationShipWithFirstApplicant:
                    //   applicant.jointApplicantRelation === 'Others'
                    //     ? applicant.relationShipWithFirstApplicant
                    //     : applicant.jointApplicantRelation,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                    // relationShipWithFirstApplicant:
                    //   applicant.jointApplicantRelation === 'Others'
                    //     ? applicant.relationShipWithFirstApplicant
                    //     : applicant.jointApplicantRelation,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                p: 4,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ mb: 2 }}>
              <CardMedia
                component="img"
                src="/images/warning-icon-red.svg"
                sx={{ width: 'unset', mx: 'auto' }}
              />
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: 'center',
                },
              }}>
              <Typography sx={{ color: '#FD3A69', lineHeight: '35px' }}>
                Disabling “Either or Survivor” will cause issues later.
              </Typography>
              <Typography sx={{ color: 'primary.main', lineHeight: '35px' }}>
                Are you willing to disable?
              </Typography>
            </Box>
            <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
              <Button
                onClick={() => {
                  setValues({
                    ...values,
                    modeOfHolding: 'joint',
                  });
                  handleClose();
                }}
                variant="outlined"
                sx={{
                  fontSize: 14,
                  color: 'primary.main',
                  minWidth: 200,
                }}>
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setValues({
                    ...values,
                    modeOfHolding: 'either or survivor',
                  });
                  handleClose();
                }}
                sx={{
                  fontSize: 14,
                  minWidth: 200,
                }}>
                No
              </Button>
            </Grid>
          </Dialog>
          <ConfirmationDialog
            message={`Are you sure you want to delete applicant ?`}
            open={applicantToDelete !== null}
            setOpen={() => setApplicantToDelete(null)}
            onSave={async () => {
              const remainedApplicants = values.applicants.map((applicant, i) => {
                const noOfApplicants = values.applicants.length;
                if (applicant.sno === applicantToDelete?.index) {
                  return {
                    ...applicant,
                    isActive: false,
                  };
                }
                if (noOfApplicants === 3 && applicant.sno === 2) {
                  return {
                    ...applicant,
                    applicant_type: '2',
                  };
                }
                return applicant;
              });
              const defaultPayload = {
                applicants: remainedApplicants.map((applicant) => {
                  const {
                    // jointApplicantRelation,
                    ...rest
                  } = applicant;
                  return {
                    ...rest,
                    // relationShipWithFirstApplicant: getRelation(jointApplicantRelation)
                    //   ? jointApplicantRelation
                    //   : applicant.relationShipWithFirstApplicant,
                  };
                }),
                modeOfHolding:
                  remainedApplicants.filter((applicant) => applicant.isActive).length === 1
                    ? 'single'
                    : values.modeOfHolding,
              };
              setApplicantToDelete(null);
              setContributorValues({ ...values, ...defaultPayload });
              // if (application?.id) {
              //   await dispatch(
              //     updateApplication({
              //       body: {
              //         ...application,
              //         ...defaultPayload,
              //         status:
              //           !application?.hasPOA &&
              //           AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //           application?.status !== 'draft' &&
              //           applyRoleBasedStatus(role)
              //             ? 'sent_to_amc_approver'
              //             : application?.status,
              //       },
              //       applicationId: application.id,
              //     })
              //   );
              // }
            }}
            onCancel={() => setApplicantToDelete(null)}
          />
        </>
      )}
    </Formik>
  );
}
